import { Sleeper } from "@models/sleeper/sleeper.model";
export class GetDYKTips {
  static readonly type = '[Edp] GetDYKTips';
  constructor(public sleeper: Sleeper) { }
}

export class ResetEdpState {
  static readonly type = '[Edp] ResetEdpState';
}
